import { Container, Row, Col, NavLink } from 'react-bootstrap';

const FooterComp = () => {
    return (
        <>
            <footer>
                <div className="bg-dark p-5">
                    <Container>
                        <div className="text-white">
                            <Row>
                                <Col sm={4} className="mb-2">
                                    <h1>The One Shop</h1>
                                    <div className="pe-5 me-5">
                                        <p>We offer a wide range of products for all your needs. We have the perfect products to meet your needs.</p>
                                    </div>
                                </Col>

                                <Col sm={3}></Col>

                                <Col sm={2} className="mb-3">
                                    <NavLink>Home</NavLink>
                                    <NavLink>About</NavLink>
                                    <NavLink>Careers</NavLink>
                                    <NavLink>Contacts</NavLink>
                                </Col>

                                <Col sm={3}>
                                    <div>Jakarta, Indonesia</div>
                                    <div>+08911981187117</div>
                                    <div>PT Satu Toko Mendunia</div>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </div>

                <div>
                    <Container>
                        <div className="text-center p-4">
                            <span className="align-middle">Built by Bagus Rinu</span>
                        </div>
                    </Container>
                </div>
            </footer>
        </>
    );
};

export default FooterComp;
